import style from './ScrollId.module.scss';

interface Props {
  id: string;
}

export default function ScrollId({ id }: Props) {
  return <div id={id} className={style.div} />;
}
